import Axios, { CancelTokenSource } from "axios";

import { API } from "utils/api-config";

import { defaultErrorResponse } from "api/defaults";

import { Tenant } from "store/environments/environment-types";
import { StorageAccount } from "store/storage-accounts/storage-accounts-types";
import {
    OperationHistory,
    OperationErrorLog,
} from "store/common/operation-types";

export const loadStorageAccount = async (
    environmentId: string,
    tenantId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<[Tenant<StorageAccount> | null, number]> => {
    const response = await API.get(
        `/environments/${environmentId}/tenants/${tenantId}/storage-accounts/default`,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};

export const loadManagementPolicyRulesHistory = async (
    environmentId: string,
    tenantId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<
    [ReadonlyArray<OperationHistory<StorageAccount>> | null, number]
> => {
    const response = await API.get(
        `/environments/${environmentId}/tenants/${tenantId}/storage-accounts/default/management-policy-rules/history`,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};

export const loadManagementPolicyRulesErrors = async (
    environmentId: string,
    tenantId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<
    [ReadonlyArray<OperationErrorLog<StorageAccount>> | null, number]
> => {
    const response = await API.get(
        `/environments/${environmentId}/tenants/${tenantId}/storage-accounts/default/management-policy-rules/errors`,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};
